import { render, staticRenderFns } from "./SubscriptionView.vue?vue&type=template&id=12701965&scoped=true&"
import script from "./SubscriptionView.vue?vue&type=script&lang=ts&"
export * from "./SubscriptionView.vue?vue&type=script&lang=ts&"
import style0 from "./SubscriptionView.vue?vue&type=style&index=0&id=12701965&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12701965",
  null
  
)

export default component.exports